import React, { useState, useMemo } from "react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface Country {
  code: string;
  country: string;
  flag: string;
}

interface CountryCodeSelectorProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

const countries: Country[] = [
  { code: "93", country: "Afghanistan", flag: "🇦🇫" },
  { code: "355", country: "Albania", flag: "🇦🇱" },
  { code: "213", country: "Algeria", flag: "🇩🇿" },
  { code: "1", country: "United States", flag: "🇺🇸" },
  { code: "376", country: "Andorra", flag: "🇦🇩" },
  { code: "244", country: "Angola", flag: "🇦🇴" },
  { code: "54", country: "Argentina", flag: "🇦🇷" },
  { code: "374", country: "Armenia", flag: "🇦🇲" },
  { code: "61", country: "Australia", flag: "🇦🇺" },
  { code: "43", country: "Austria", flag: "🇦🇹" },
  { code: "994", country: "Azerbaijan", flag: "🇦🇿" },
  { code: "973", country: "Bahrain", flag: "🇧🇭" },
  { code: "880", country: "Bangladesh", flag: "🇧🇩" },
  { code: "375", country: "Belarus", flag: "🇧🇾" },
  { code: "32", country: "Belgium", flag: "🇧🇪" },
  { code: "501", country: "Belize", flag: "🇧🇿" },
  { code: "229", country: "Benin", flag: "🇧🇯" },
  { code: "975", country: "Bhutan", flag: "🇧🇹" },
  { code: "591", country: "Bolivia", flag: "🇧🇴" },
  { code: "387", country: "Bosnia and Herzegovina", flag: "🇧🇦" },
  { code: "267", country: "Botswana", flag: "🇧🇼" },
  { code: "55", country: "Brazil", flag: "🇧🇷" },
  { code: "673", country: "Brunei", flag: "🇧🇳" },
  { code: "359", country: "Bulgaria", flag: "🇧🇬" },
  { code: "226", country: "Burkina Faso", flag: "🇧🇫" },
  { code: "257", country: "Burundi", flag: "🇧🇮" },
  { code: "855", country: "Cambodia", flag: "🇰🇭" },
  { code: "237", country: "Cameroon", flag: "🇨🇲" },
  { code: "1", country: "Canada", flag: "🇨🇦" },
  { code: "238", country: "Cape Verde", flag: "🇨🇻" },
  { code: "236", country: "Central African Republic", flag: "🇨🇫" },
  { code: "235", country: "Chad", flag: "🇹🇩" },
  { code: "56", country: "Chile", flag: "🇨🇱" },
  { code: "86", country: "China", flag: "🇨🇳" },
  { code: "57", country: "Colombia", flag: "🇨🇴" },
  { code: "269", country: "Comoros", flag: "🇰🇲" },
  { code: "242", country: "Congo", flag: "🇨🇬" },
  { code: "243", country: "Congo (DRC)", flag: "🇨🇩" },
  { code: "506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "225", country: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "385", country: "Croatia", flag: "🇭🇷" },
  { code: "53", country: "Cuba", flag: "🇨🇺" },
  { code: "357", country: "Cyprus", flag: "🇨🇾" },
  { code: "420", country: "Czech Republic", flag: "🇨🇿" },
  { code: "45", country: "Denmark", flag: "🇩🇰" },
  { code: "253", country: "Djibouti", flag: "🇩🇯" },
  { code: "1767", country: "Dominica", flag: "🇩🇲" },
  { code: "1809", country: "Dominican Republic", flag: "🇩🇴" },
  { code: "593", country: "Ecuador", flag: "🇪🇨" },
  { code: "20", country: "Egypt", flag: "🇪🇬" },
  { code: "503", country: "El Salvador", flag: "🇸🇻" },
  { code: "240", country: "Equatorial Guinea", flag: "🇬🇶" },
  { code: "291", country: "Eritrea", flag: "🇪🇷" },
  { code: "372", country: "Estonia", flag: "🇪🇪" },
  { code: "251", country: "Ethiopia", flag: "🇪🇹" },
  { code: "679", country: "Fiji", flag: "🇫🇯" },
  { code: "358", country: "Finland", flag: "🇫🇮" },
  { code: "33", country: "France", flag: "🇫🇷" },
  { code: "241", country: "Gabon", flag: "🇬🇦" },
  { code: "220", country: "Gambia", flag: "🇬🇲" },
  { code: "995", country: "Georgia", flag: "🇬🇪" },
  { code: "49", country: "Germany", flag: "🇩🇪" },
  { code: "233", country: "Ghana", flag: "🇬🇭" },
  { code: "30", country: "Greece", flag: "🇬🇷" },
  { code: "1473", country: "Grenada", flag: "🇬🇩" },
  { code: "502", country: "Guatemala", flag: "🇬🇹" },
  { code: "224", country: "Guinea", flag: "🇬🇳" },
  { code: "245", country: "Guinea-Bissau", flag: "🇬🇼" },
  { code: "592", country: "Guyana", flag: "🇬🇾" },
  { code: "509", country: "Haiti", flag: "🇭🇹" },
  { code: "504", country: "Honduras", flag: "🇭🇳" },
  { code: "852", country: "Hong Kong", flag: "🇭🇰" },
  { code: "36", country: "Hungary", flag: "🇭🇺" },
  { code: "354", country: "Iceland", flag: "🇮🇸" },
  { code: "91", country: "India", flag: "🇮🇳" },
  { code: "62", country: "Indonesia", flag: "🇮🇩" },
  { code: "98", country: "Iran", flag: "🇮🇷" },
  { code: "964", country: "Iraq", flag: "🇮🇶" },
  { code: "353", country: "Ireland", flag: "🇮🇪" },
  { code: "39", country: "Italy", flag: "🇮🇹" },
  { code: "1876", country: "Jamaica", flag: "🇯🇲" },
  { code: "81", country: "Japan", flag: "🇯🇵" },
  { code: "962", country: "Jordan", flag: "🇯🇴" },
  { code: "7", country: "Kazakhstan", flag: "🇰🇿" },
  { code: "254", country: "Kenya", flag: "🇰🇪" },
  { code: "686", country: "Kiribati", flag: "🇰🇮" },
  { code: "850", country: "North Korea", flag: "🇰🇵" },
  { code: "82", country: "South Korea", flag: "🇰🇷" },
  { code: "965", country: "Kuwait", flag: "🇰🇼" },
  { code: "996", country: "Kyrgyzstan", flag: "🇰🇬" },
  { code: "856", country: "Laos", flag: "🇱🇦" },
  { code: "371", country: "Latvia", flag: "🇱🇻" },
  { code: "961", country: "Lebanon", flag: "🇱🇧" },
  { code: "266", country: "Lesotho", flag: "🇱🇸" },
  { code: "231", country: "Liberia", flag: "🇱🇷" },
  { code: "218", country: "Libya", flag: "🇱🇾" },
  { code: "423", country: "Liechtenstein", flag: "🇱🇮" },
  { code: "370", country: "Lithuania", flag: "🇱🇹" },
  { code: "352", country: "Luxembourg", flag: "🇱🇺" },
  { code: "853", country: "Macao", flag: "🇲🇴" },
  { code: "389", country: "Macedonia", flag: "🇲🇰" },
  { code: "261", country: "Madagascar", flag: "🇲🇬" },
  { code: "265", country: "Malawi", flag: "🇲🇼" },
  { code: "60", country: "Malaysia", flag: "🇲🇾" },
  { code: "960", country: "Maldives", flag: "🇲🇻" },
  { code: "223", country: "Mali", flag: "🇲🇱" },
  { code: "356", country: "Malta", flag: "🇲🇹" },
  { code: "692", country: "Marshall Islands", flag: "🇲🇭" },
  { code: "222", country: "Mauritania", flag: "🇲🇷" },
  { code: "230", country: "Mauritius", flag: "🇲🇺" },
  { code: "52", country: "Mexico", flag: "🇲🇽" },
  { code: "691", country: "Micronesia", flag: "🇫🇲" },
  { code: "373", country: "Moldova", flag: "🇲🇩" },
  { code: "377", country: "Monaco", flag: "🇲🇨" },
  { code: "976", country: "Mongolia", flag: "🇲🇳" },
  { code: "382", country: "Montenegro", flag: "🇲🇪" },
  { code: "212", country: "Morocco", flag: "🇲🇦" },
  { code: "258", country: "Mozambique", flag: "🇲🇿" },
  { code: "95", country: "Myanmar", flag: "🇲🇲" },
  { code: "264", country: "Namibia", flag: "🇳🇦" },
  { code: "674", country: "Nauru", flag: "🇳🇷" },
  { code: "977", country: "Nepal", flag: "🇳🇵" },
  { code: "31", country: "Netherlands", flag: "🇳🇱" },
  { code: "64", country: "New Zealand", flag: "🇳🇿" },
  { code: "505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "227", country: "Niger", flag: "🇳🇪" },
  { code: "234", country: "Nigeria", flag: "🇳🇬" },
  { code: "47", country: "Norway", flag: "🇳🇴" },
  { code: "968", country: "Oman", flag: "🇴🇲" },
  { code: "92", country: "Pakistan", flag: "🇵🇰" },
  { code: "680", country: "Palau", flag: "🇵🇼" },
  { code: "970", country: "Palestine", flag: "🇵🇸" },
  { code: "507", country: "Panama", flag: "🇵🇦" },
  { code: "675", country: "Papua New Guinea", flag: "🇵🇬" },
  { code: "595", country: "Paraguay", flag: "🇵🇾" },
  { code: "51", country: "Peru", flag: "🇵🇪" },
  { code: "63", country: "Philippines", flag: "🇵🇭" },
  { code: "48", country: "Poland", flag: "🇵🇱" },
  { code: "351", country: "Portugal", flag: "🇵🇹" },
  { code: "974", country: "Qatar", flag: "🇶🇦" },
  { code: "40", country: "Romania", flag: "🇷🇴" },
  { code: "7", country: "Russia", flag: "🇷🇺" },
  { code: "250", country: "Rwanda", flag: "🇷🇼" },
  { code: "1869", country: "Saint Kitts and Nevis", flag: "🇰🇳" },
  { code: "1758", country: "Saint Lucia", flag: "🇱🇨" },
  { code: "1784", country: "Saint Vincent and the Grenadines", flag: "🇻🇨" },
  { code: "685", country: "Samoa", flag: "🇼🇸" },
  { code: "378", country: "San Marino", flag: "🇸🇲" },
  { code: "239", country: "São Tomé and Príncipe", flag: "🇸🇹" },
  { code: "966", country: "Saudi Arabia", flag: "🇸🇦" },
  { code: "221", country: "Senegal", flag: "🇸🇳" },
  { code: "381", country: "Serbia", flag: "🇷🇸" },
  { code: "248", country: "Seychelles", flag: "🇸🇨" },
  { code: "232", country: "Sierra Leone", flag: "🇸🇱" },
  { code: "65", country: "Singapore", flag: "🇸🇬" },
  { code: "421", country: "Slovakia", flag: "🇸🇰" },
  { code: "386", country: "Slovenia", flag: "🇸🇮" },
  { code: "677", country: "Solomon Islands", flag: "🇸🇧" },
  { code: "252", country: "Somalia", flag: "🇸🇴" },
  { code: "27", country: "South Africa", flag: "🇿🇦" },
  { code: "211", country: "South Sudan", flag: "🇸🇸" },
  { code: "34", country: "Spain", flag: "🇪🇸" },
  { code: "94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "249", country: "Sudan", flag: "🇸🇩" },
  { code: "597", country: "Suriname", flag: "🇸🇷" },
  { code: "268", country: "Swaziland", flag: "🇸🇿" },
  { code: "46", country: "Sweden", flag: "🇸🇪" },
  { code: "41", country: "Switzerland", flag: "🇨🇭" },
  { code: "963", country: "Syria", flag: "🇸🇾" },
  { code: "886", country: "Taiwan", flag: "🇹🇼" },
  { code: "992", country: "Tajikistan", flag: "🇹🇯" },
  { code: "255", country: "Tanzania", flag: "🇹🇿" },
  { code: "66", country: "Thailand", flag: "🇹🇭" },
  { code: "670", country: "Timor-Leste", flag: "🇹🇱" },
  { code: "228", country: "Togo", flag: "🇹🇬" },
  { code: "676", country: "Tonga", flag: "🇹🇴" },
  { code: "1868", country: "Trinidad and Tobago", flag: "🇹🇹" },
  { code: "216", country: "Tunisia", flag: "🇹🇳" },
  { code: "90", country: "Turkey", flag: "🇹🇷" },
  { code: "993", country: "Turkmenistan", flag: "🇹🇲" },
  { code: "688", country: "Tuvalu", flag: "🇹🇻" },
  { code: "256", country: "Uganda", flag: "🇺🇬" },
  { code: "380", country: "Ukraine", flag: "🇺🇦" },
  { code: "971", country: "UAE", flag: "🇦🇪" },
  { code: "44", country: "United Kingdom", flag: "🇬🇧" },
  { code: "598", country: "Uruguay", flag: "🇺🇾" },
  { code: "998", country: "Uzbekistan", flag: "🇺🇿" },
  { code: "678", country: "Vanuatu", flag: "🇻🇺" },
  { code: "379", country: "Vatican City", flag: "🇻🇦" },
  { code: "58", country: "Venezuela", flag: "🇻🇪" },
  { code: "84", country: "Vietnam", flag: "🇻🇳" },
  { code: "967", country: "Yemen", flag: "🇾🇪" },
  { code: "260", country: "Zambia", flag: "🇿🇲" },
  { code: "263", country: "Zimbabwe", flag: "🇿🇼" },
];

export default function CountryCodeSelector({
  value,
  onValueChange,
  className,
}: CountryCodeSelectorProps) {
  const [open, setOpen] = useState(false);

  const selectedCountry = useMemo(
    () => countries.find((country) => country.code === value),
    [value]
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn(
            "w-full justify-between border-2 border-neutral-light bg-white text-gray-900 font-verona",
            className
          )}
        >
          <div className="flex items-center gap-2">
            {selectedCountry ? (
              <>
                <span className="text-lg">{selectedCountry.flag}</span>
                <span>+{selectedCountry.code}</span>
              </>
            ) : (
              "Select country..."
            )}
          </div>
          <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-0 bg-white border shadow-lg">
        <Command>
          <CommandInput
            placeholder="Search country..."
            className="font-verona"
          />
          <CommandEmpty className="font-verona">
            No country found.
          </CommandEmpty>
          <CommandList>
            <CommandGroup>
              {countries.map((country) => (
                <CommandItem
                  key={country.code}
                  value={`${country.country} ${country.code}`}
                  onSelect={() => {
                    onValueChange(country.code);
                    setOpen(false);
                  }}
                  className="font-verona cursor-pointer"
                >
                  <div className="flex items-center gap-2 w-full">
                    <span className="text-lg">{country.flag}</span>
                    <span className="flex-1">{country.country}</span>
                    <span className="text-gray-500">+{country.code}</span>
                  </div>
                  <Check
                    className={cn(
                      "ml-auto h-4 w-4",
                      value === country.code ? "opacity-100" : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
